class PaymentController {
  constructor ($state, $http, $filter, $cookies, $window, modalService) {
    this.$http = $http;
    this.$state = $state;
    this.$filter = $filter;
    this.$cookies = $cookies;
    this.modalService = modalService;

    this.request = $state.params.request || this.getRequestCookie();

    this.processing = false;

    if (!this.request) {
      this.$state.go('app.home');
    } else {
      this.request.payment = {};
      this.years = this.getYears(10);
      this.alerts = [];
    }

    $window.scrollTo(0, 0);
  }

  showCVN () {
    this.modalService.showCVN();
  }

  showBookingFee () {
    this.modalService.showBookingFee();
  }

  getRequestCookie () {
    var request = this.$cookies.get('request');
    if (!request) return null;
    if (request == undefined) return null;

    return JSON.parse(request);
  }

  getYears (range) {
    var currentYear = new Date().getFullYear();
    var years = [];
    for (var i = 0; i < range + 1; i++) {
      years.push(currentYear + i);
    }
    return years;
  }

  pay () {
    this.alerts = [];
    if (!this.request.payment.specialInstructions) {
      this.alerts.push({ msg: 'You need to agree on terms and conditions.' });
    }

    if (!this.request.payment.CardHolderName) {
      this.alerts.push({ msg: 'Card holder name is invalid.' });
    }
    if (!this.request.payment.CardType) {
      this.alerts.push({ msg: 'Card type is invalid.' });
    }
    if (!this.request.payment.CardNumber) {
      this.alerts.push({ msg: 'Card number is invalid.' });
    }
    if (!this.request.payment.CardExpiryMonth) {
      this.alerts.push({ msg: 'Card expiration month is invalid.' });
    }
    if (!this.request.payment.CardExpiryYear) {
      this.alerts.push({ msg: 'Card expiration year is invalid.' });
    }
    if (!this.request.payment.CVN) {
      this.alerts.push({ msg: 'CVN is invalid.' });
    }

    if (this.alerts.length == 0) {
      // Go to confirmation
      // this.$state.go('app.payment', {
      //  request: this.request
      // });

      this.sendPayment();
    }
  }
  sendPayment () {
    let selfController = this;
    this.processing = true;
    this.$http
      .post('/Ajax.aspx/Payment', {
        LocalityID: this.request.Locality.ID,
        wasteTypes: this.request.WasteType.ID,
        WasteType: {
          Name: this.request.WasteType.Name,
          Excludes: this.request.WasteType.Excludes
        },
        dateStart: this.$filter('date')(this.request.pickupdate, 'dd/MM/yyyy'),
        dateEnd: this.$filter('date')(this.request.returndate, 'dd/MM/yyyy'),
        PostCode: this.request.PostCode,
        SkipTypes: this.request.fare.ID,
        SkipType: this.request.fare.Name,
        CustomerInformation: {
          PrivateLand: this.request.delivery.PrivateLand,
          PublicLand: this.request.delivery.PublicLand,
          address: this.request.delivery.address,
          email: this.request.delivery.email,
          instructions: this.request.delivery.instructions,
          mobile: this.request.delivery.mobile,
          phone: this.request.delivery.phone,
          name: this.request.delivery.name,
          townID: this.request.delivery.Town.ID,
          Town: this.request.delivery.Town.Name
        },
        Payment: {
          CardNumber: this.request.payment.CardNumber,
          CardExpiryMonth: this.request.payment.CardExpiryMonth,
          CardExpiryYear: this.request.payment.CardExpiryYear,
          CardHolderName: this.request.payment.CardHolderName,
          CVN: this.request.payment.CVN,
          CustomerNameFullName: this.request.payment.CustomerNameFullName,
          CardType: this.request.payment.CardType
        },
        PaymentRef: this.request.paymentRef
      })
      .then(function (response) {
        selfController.processing = false;
        selfController.request.orderNumber = response.data.orderNumber;
        if (response.data.success) {
          // /goto confirmmation
          selfController.$state.go('app.confirmation', {
            request: selfController.request
          });
        } else {
          selfController.alerts = [{ msg: response.data.error }];
          // selfController.$state.go('app.confirmation');
        }
      });
  }
}

PaymentController.$inject = [
  '$state',
  '$http',
  '$filter',
  '$cookies',
  '$window',
  'modalService'
];

export { PaymentController };



/** WEBPACK FOOTER **
 ** ./src/app/components/booking/payment/payment.controller.js
 **/